/* eslint-disable jsx-a11y/anchor-is-valid */
import List from 'devextreme-react/list';
import jQuery from 'jquery';
import { orderBy } from 'lodash';
import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';

import Notificacao from './Notificacao';
import { logOutUser, trocarEmpresa } from '../../actions';
import { smoothlyMenu, tenantsClose, tenantsOpen } from '../helpers';

const sentinelaURL = process.env.REACT_APP_SENTINELA_FRONT_END;

const TopNavbar = ({ empresas, pessoaLogada, changeCompanyAction, logoutAction }) => {
  useEffect(() => {
    tenantsClose();
  });

  const toggleNavigation = () => {
    jQuery('body').toggleClass('mini-navbar');
    smoothlyMenu();
  };

  function ItemTemplate({ id, nome }) {
    return (
      <div key={id} className="row" onClick={() => changeCompanyAction(id)}>
        <div
          className="col-md-10"
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          <span>{nome}</span>
        </div>
        <div className="col-md-2">
          <i className="fa fa-sign-in fa-2x" />
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <div className="row border-bottom">
        <nav className="navbar navbar-static-top" role="navigation" style={{ marginBottom: 0 }}>
          <div className="navbar-header">
            <button
              className="minimalize-styl-2 btn btn-primary"
              type="button"
              onClick={() => toggleNavigation()}
            >
              <i className="fa fa-bars" />
            </button>
          </div>
          <ul className="nav navbar-top-links navbar-right">
            <li>
              <span className="m-r-sm text-muted welcome-message">{pessoaLogada.empresa}</span>
            </li>
            {empresas.length > 1 && (
              <li>
                <a onClick={tenantsOpen}>
                  <i className="fa fa-retweet" />
                </a>
              </li>
            )}
            <li>
              <Notificacao />
            </li>
            <li className="dropdown">
              <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                <i className="fa fa-caret-down fa-lg" />
              </a>

              <ul className="dropdown-menu dropdown-alerts">
                <li>
                  <a className="dropdown-item" href={`${sentinelaURL}/#/`} onClick={logoutAction}>
                    <i className="fa fa-sign-in" /> Acessar meus produtos
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#/configuracoes">
                    <i className="fa fa-cog" /> Configurações
                  </a>
                </li>
                <li className="dropdown-divider" />
                <li>
                  <a
                    className="dropdown-item"
                    href={`${sentinelaURL}/#/logout`}
                    onClick={logoutAction}
                  >
                    <i className="fa fa-sign-out" /> Sair
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>

      <div id="right-sidebar" className="thin-scroll">
        <div className="sidebar-container">
          <div className="sidebar-title">
            <h3>
              <i className="fa fa-building-o" /> Seleção de Empresas
            </h3>
          </div>

          <div style={{ padding: 5 }}>
            <List
              dataSource={orderBy(empresas, 'nome')}
              itemRender={ItemTemplate}
              searchExpr="nome"
              searchEnabled
              searchMode="contains"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  pessoaLogada: state.usuario.pessoaLogada,
  empresas: state.empresa.empresas,
});

const mapDispatchToProps = {
  logoutAction: logOutUser,
  changeCompanyAction: trocarEmpresa,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopNavbar);
